import { useMatch } from "react-router-dom";
import { RoutePaths } from "@/core/constants/RoutePaths";
import { AreasTabSkeleton } from "./components/AreasTab/skeleton";
import { MemberDirectorySkeleton } from "./components/MemberDirectory/skeleton";
import { TeamTabs } from "./components/TeamTabs";
import styles from "./TeamManagementPage.module.css";

/** Aba Pessoas carregando (fallback da rota índice da Equipe). */
export const TeamPeopleTabSkeleton = MemberDirectorySkeleton;

/** Aba Áreas carregando (fallback da rota `/team-management/areas`). */
export const TeamAreasTabSkeleton = AreasTabSkeleton;

/**
 * Esqueleto da página da Equipe: abas e títulos fixos aparecem como conteúdo
 * real; só a lista e o painel esperam os dados. Segue a aba da URL.
 */
export function TeamManagementPageSkeleton() {
  const onAreasTab = useMatch(RoutePaths.TEAM_MANAGEMENT_AREAS) !== null;

  return (
    <div className={styles.page}>
      <TeamTabs />
      <div className={styles.content}>
        {onAreasTab ? <AreasTabSkeleton /> : <MemberDirectorySkeleton />}
      </div>
    </div>
  );
}
